module.exports = { "default": require("core-js/library/fn/number/max-safe-integer"), __esModule: true };